import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        backgroundColor: tokens.colorNeutralBackground2,
    },
    header: {
        paddingLeft: '16px',
        paddingRight: '16px',
        paddingTop: '12px',
        paddingBottom: '12px',
        borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    },
    title: {
        margin: '0',
        fontSize: tokens.fontSizeBase400,
        fontWeight: tokens.fontWeightSemibold,
        color: tokens.colorNeutralForeground1,
    },
    treeContainer: {
        flex: 1,
        overflowY: 'auto',
        paddingTop: '8px',
        paddingBottom: '8px',
    },
});
